"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public'; // eslint-plugin-vue's max-len rule reads the entire file, including the CSS. so we can't use this
// here as some of the rules cannot be broken up any smaller

/* eslint-disable max-len */

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _MediaViewer = _interopRequireDefault(require("./MediaViewer"));

var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));

var _MessageInfo = _interopRequireDefault(require("./MessageInfo"));

var _default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default,
    MessageInfo: _MessageInfo.default,
    MediaViewer: _MediaViewer.default
  },
  props: ['ml', 'message', 'idx'],
  data: function data() {
    return {};
  },
  computed: {
    userColour: function userColour() {
      return this.ml.userColour(this.message.user);
    }
  },
  methods: {
    getNetwork: function getNetwork() {
      return this.ml.buffer.getNetwork();
    },
    isHoveringOverMessage: function isHoveringOverMessage(message) {
      return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
    },
    userMode: function userMode(user) {
      return this.ml.buffer.userMode(user);
    },
    userModePrefix: function userModePrefix(user) {
      return this.ml.buffer.userModePrefix(user);
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageCompact"]
window._kiwi_exports.components.MessageListMessageCompact = exports.default ? exports.default : exports;
